import { Modal, Button, Checkbox, List, ListItemButton, ListItemText, Box, Typography, CircularProgress } from '@mui/material';

interface GoogleCalendar {
  id: string;
  summary: string;
}

interface CalendarSelectionModalProps {
  open: boolean;
  calendars: GoogleCalendar[];
  selectedCalendars: string[];
  onSelect: (selected: string[]) => void;
  onClose: () => void;
  onSync: () => void;
}

const CalendarSelectionModal = ({ open, calendars, selectedCalendars, onSelect, onClose, onSync }: CalendarSelectionModalProps) => {
  const handleToggle = (calendarId: string) => {
    const currentIndex = selectedCalendars.indexOf(calendarId);
    const newSelected = [...selectedCalendars];

    if (currentIndex === -1) {
      newSelected.push(calendarId);
    } else {
      newSelected.splice(currentIndex, 1);
    }

    onSelect(newSelected);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ width: 400, bgcolor: 'background.paper', p: 4, mx: 'auto', mt: '10%', borderRadius: 1 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          Select Google Calendars
        </Typography>
        {calendars.length === 0 ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
            <CircularProgress />
          </Box>
        ) : (
          <List>
            {calendars.map((calendar) => (
              <ListItemButton key={calendar.id} onClick={() => handleToggle(calendar.id)}>
                <ListItemText primary={calendar.summary} />
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                  <Checkbox
                    edge="end"
                    onChange={() => handleToggle(calendar.id)}
                    checked={selectedCalendars.indexOf(calendar.id) !== -1}
                  />
                </Box>
              </ListItemButton>
            ))}
          </List>
        )}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Button variant="outlined" onClick={onClose} sx={{ mr: 1 }}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onSync}>
            Sync Events
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CalendarSelectionModal;
